module.exports = __webpack_public_path__ + "media/img/why/banner-demo-875332319c45cd69f233e505b371fc03.jpg";